// extracted by mini-css-extract-plugin
module.exports = {"UpgradePurchase":"AddDataPurchase_UpgradePurchase__7KpvZ","Back":"AddDataPurchase_Back__9gNHV"};